// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__25LbY","label":"SetPasswdForm_label__dHw7t"};